import {Component, OnDestroy, OnInit} from '@angular/core';
import {NgSelectConfig} from '@ng-select/ng-select';
import {AuthenticationService} from './services/auth/authentication.service';
import {Subscription} from 'rxjs';
import {NavigationEnd, Router} from '@angular/router';
import {LocalStorage} from './utils/storage';
import {Settings} from './settings/settings';
import * as appVersion from '../compiled-version';
import {CameraFlowService} from './services/camera-flow.service';
import {HttpClient} from '@angular/common/http';
import {environment} from '../environments/environment';
import {User} from './classes/user';
import {Routenames} from './routenames';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
    title = 'tsned';

    private subscriptions = new Subscription();
    private checkTokenInterval: ReturnType<typeof setInterval>;
    env = environment;

    parentUser: User;
    user: User;

    constructor(private authenticationService: AuthenticationService,
                private http: HttpClient,
                private router: Router,
                private ngSelectConfig: NgSelectConfig,
                private cameraFlow: CameraFlowService) {
        window.addEventListener('focus', () => {
            this.http.get<{ buildNumber: string }>('/assets/version.json?v=' + (new Date()).getTime()).subscribe(version => {
                setTimeout(() => {
                    Settings.versionUpdateAvailable = version.buildNumber !== appVersion.compiledVersion.buildNumber;
                });
            });
        });

        this.ngSelectConfig.notFoundText = 'Geen items gevonden';
        this.ngSelectConfig.typeToSearchText = 'Typ om te zoeken';
        this.ngSelectConfig.loadingText = 'Aan het laden...';
        this.ngSelectConfig.clearAllText = 'Verwijder alles';
        this.ngSelectConfig.addTagText = 'Voeg item toe';
    }

    ngOnInit() {
        // A photo flow that was killed and not picked up again in time is logged and removed
        this.cameraFlow.discardExpired();

        if (!LocalStorage.userToken) {
            this.router.initialNavigation();
        } else if (!this.authenticationService.isTokenExpired()) {
            // Een bijna verlopen token wordt na de eerste navigatie op de achtergrond ververst
            this.loadCurrentUserAndStartNavigation();
        } else {
            this.authenticationService.checkToken().then(result => {
                if (result === 'valid') {
                    this.loadCurrentUserAndStartNavigation();
                } else if (result === 'retry') {
                    this.router.initialNavigation();
                }
                // loggedOut: checkToken navigeert zelf naar uitloggen
            });
        }

        this.subscriptions.add(this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.authenticationService.checkToken();
            }
        }));
        this.checkTokenInterval = setInterval(() => this.authenticationService.checkToken(), 15 * 60 * 1000);
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') {
                this.authenticationService.checkToken();
            }
        });
        // Chromium Page Lifecycle API: vuurt alleen na een echt bevroren tab
        document.addEventListener('resume', () => this.authenticationService.checkToken());
        // Firefox/Safari: herstel uit de bfcache
        window.addEventListener('pageshow', (event: PageTransitionEvent) => {
            if (event.persisted) {
                this.authenticationService.checkToken();
            }
        });

        this.subscriptions.add(this.authenticationService.loggedIn.subscribe(loggedIn => {
            if (loggedIn) {
                this.parentUser = LocalStorage.parentUser;
                this.user = LocalStorage.user;
            }
        }));
        this.parentUser = LocalStorage.parentUser;
        this.user = LocalStorage.user;
    }

    backToParentUser() {
        this.router.navigateByUrl(`/${Routenames.Logout}`);
    }

    private loadCurrentUserAndStartNavigation() {
        this.subscriptions.add(this.authenticationService.getCurrentUser().subscribe(() => {
            this.router.initialNavigation();
        }));
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
        clearInterval(this.checkTokenInterval);
    }
}
